import { createSelector } from './selectorWrapper'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { pageSelectors } from './basicState'

export const showOtherFormatsSelector = createSelector(
  pageSelectors.otherFormats,
  (otherFormats?: WpsRuntime.atv.wps.OtherFormatsModelProps) =>
    Boolean(otherFormats && otherFormats.actions && otherFormats.actions.length)
)

